import { validationTypes } from "../../components/FinalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../data/formFieldType";
import { GridColumnType } from "../../data/gridColumnType";

// Add/Edit form-fields configuration
const addEditInfo = {
    name: "Add Job Titile",
    initialState: {
        positionName: "",
        isEnable: true,
        departmentId: "",
        description: "",
        // requiredSkillsIds: "",
        // optionalSkillsIds: "",
    },
    section: [
        {
            title: "Profile Section",
            row: {},
            style: {
                sectionStyle: "row",
            },
            fields: [
                {
                    id: "positionName",
                    label: "Job Position Name",
                    Field_Name: "Position Name",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "positionName",
                    fieldSetting: {
                        placeholder: "Enter Job Position Name",
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-md-6",
                    },
                },
                {
                    id: "departmentId",
                    label: "Department Name",
                    Field_Name: "Department Name",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "departmentId",
                    fieldSetting: {
                        placeholder: "Please Select Department Name",
                        //   isMultiSelect: true,
                        options: [],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-md-6",
                    },
                },
                {
                    id: "description",
                    label: "Description",
                    Field_Name: "Description",
                    fieldType: FormFieldTypes.TEXTAREA,
                    dataField: "description",
                    fieldSetting: {
                        placeholder: "Enter Description",
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-md-12 ",
                    },
                },
                {
                    id: "isEnable",
                    label: "Is Enable",
                    Field_Name: "isEnable",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "isEnable",
                    style: {
                        containerCss: "col-md-6 mb-3 is-enable",
                    },
                },
            ]
        }
    ],
    formSetting: {
        isViewOnly: true,
    }
};


//** Table columns configuration */
export const GridConfig = {
    columns: [
        {
            name: "Job Position Name",
            fieldName: "positionName",
            allowShort: false,
        },
        {
            name: "Department Name",
            fieldName: "departmentName",
            allowShort: false,
        },
        // {
        //     name: "Required Skills",
        //     fieldName: "requiredSkillsIds",
        //     allowShort: false,
        // },
        // {
        //     name: "Optional Skills",
        //     fieldName: "optionalSkillsIds",
        //     allowShort: false,
        // },
        {
            name: "Is Enable",
            colType: GridColumnType.CHECKBOX,
            fieldName: "isEnable",
            allowShort: false,
        },
        {
            name: "Date",
            fieldName: "createdAt",
            colType: GridColumnType.DATE,
            colSettings: {
                format: "DD/MM/YYYY"
            },
            allowShort: false,
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: true,
            }
        },
    ],
}

export default addEditInfo;